// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { Add_City_Action } from '../../Redux/Actions/CityAction';
// import { Notify } from '../../Utility/Notify';
// import { Link } from 'react-router-dom';
// import AddIcon from '@mui/icons-material/Add';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material';

// export const AddCity = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const dispatch = useDispatch();
//   const [cityname, setcityName] = useState('');
//   const [loading, setloading] = useState(true);

//   const oncitynamechange = (e) => {
//     setcityName(e.target.value);
//   };

//   const onsubmitadd = async (e) => {
//     e.preventDefault();
//     setloading(true);
//     await dispatch(
//       Add_City_Action({
//         name: cityname,
//       }),
//     );

//     setloading(false);
//   };

//   const resAdd = useSelector((state) => state.AllCities.city);
//   useEffect(() => {
//     if (loading === false) {
//       if (resAdd && resAdd.status === 201) {
//         Notify('success', 'City added successfully', 'success');
//         setTimeout(() => {
//           window.location.reload(false);
//         }, 1500);
//         setcityName('');
//       }
//     }
//   }, [loading]);

//   //============================================================

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className=' d-flex  w-100' >
//             <div className='mx-4 '>Add City</div>
//             <a style={{textDecoration:'none'}} href='/client' className='goback'>{"<<"} Go Back </a>
//         </div> */}

//           <div className="d-flex justify-content-between">
//             <div>
//               <Link
//                 to={
//                   userlogin?.data?.role === 'Admin'
//                     ? '/AllLeadsForAdmin'
//                     : userlogin?.data?.role === 'Marketer'
//                       ? '/ALLLeadsForMarketer'
//                       : userlogin?.data?.role === 'Accountant'
//                         ? '/LeadsForAccountant'
//                         : '/Dashboard'
//                 }
//                 style={{ textDecoration: 'none', color: '#102dff' }}
//               >
//                 <span style={{ fontWeight: 'bold' }}>Home</span>
//               </Link>

//               <KeyboardDoubleArrowRightIcon />

//               <Link
//                 to="/AllCitiesShow"
//                 style={{ textDecoration: 'none', color: '#666', fontWeight: 'bold' }}
//               >
//                 <span>All Cities</span>
//               </Link>
//               <KeyboardDoubleArrowRightIcon />
//               <span style={{ color: '#666' }}>Add City</span>
//             </div>
//           </div>

//           {/* <div className='d-flex w-100 '>
//             <Link to={`/AllCitiesShow`} className='w-100'>
//             <div className='public-color btn btn-success icon-plus addnewclientbtn w-100 my-2' style={{background:'#0F7687'}} ><VisibilityIcon/> View All Cities</div>
//             </Link>
//             </div> */}

//           <Container
//             style={{
//               background: mode === 'dark' ? '#333' : '#fff',
//               padding: '25px',
//               borderRadius: '15px',
//               marginTop: '30px',
//             }}
//           >
//             <div style={{ marginTop: '30px' }}>
//               <label for="name">City Name*</label>
//               <input
//                 onChange={oncitynamechange}
//                 value={cityname}
//                 className="inputsaddclient"
//                 type="text"
//                 id="name"
//                 name="City name"
//                 placeholder="City name.."
//               />
//             </div>
//           </Container>
//           <div className="d-flex justify-content-center">
//             <div
//               onClick={onsubmitadd}
//               className="addnewclient"
//               style={{ textAlign: 'center', background: '#102dff' }}
//               type="submit"
//             >
//               <AddIcon /> Add City
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };
















// 20-5-2026

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { Add_City_Action } from '../../Redux/Actions/CityAction';
import { Notify } from '../../Utility/Notify';
import AddIcon from '@mui/icons-material/Add';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const AddCity = () => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ✅ sidebar sync */
  const sidebarWidth = useSidebarWidth();

  const [cityname, setCityname] = useState('');
  const [loading,  setLoading]  = useState(true);
  const [sending,  setSending]  = useState(false);

  const onsubmitadd = async (e) => {
    e.preventDefault();
    if (!cityname.trim()) return Notify('error', 'City name is required', 'error');
    setLoading(true);
    setSending(true);
    await dispatch(Add_City_Action({ name: cityname.trim() }));
    setLoading(false);
    setSending(false);
  };

  const resAdd = useSelector((s) => s.AllCities.city);
  useEffect(() => {
    if (loading === false) {
      if (resAdd?.status === 201) {
        Notify('success', 'City added successfully', 'success');
        setCityname('');
        setTimeout(() => navigate('/AllCitiesShow'), 1200);
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to="/AllCitiesShow" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Cities
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Add New City</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
              Add New City
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Add a new city to the CRM location database
            </p>
          </div>

          {/* field */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>City Name *</label>
            <input
              style={inputStyle}
              value={cityname}
              onChange={e => setCityname(e.target.value)}
              type="text"
              placeholder="e.g. Dubai, Abu Dhabi"
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={e => { if (e.key === 'Enter') onsubmitadd(e); }}
              autoFocus
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full city name as it will appear across the system
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!sending ? onsubmitadd : null}
              disabled={sending}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { if (!sending) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              {sending
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Adding…</span></>
                : <><AddIcon sx={{ fontSize: 17 }} /><span>Add City</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/AllCitiesShow')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8'; e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};
